import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const DownloadAttendancePdf = (attendanceData, companyName, logo, setOpenBackdrop) => {
    // 1. Validate Data
    const dataList = Array.isArray(attendanceData) ? attendanceData : [];

    if (dataList.length === 0) {
        alert("No attendance data found to print!");
        return;
    }

    const doc = new jsPDF('p', 'mm', 'a4'); // Portrait, millimeters, A4 size
    setOpenBackdrop(true);

    try {
        // --- 1. Header Section (Company Info) ---
        if (logo) {
            // Adjust dimensions (x, y, width, height)
            doc.addImage(logo, 'PNG', 14, 10, 15, 15);
        }
        
        doc.setFontSize(18);
        doc.setTextColor(25, 118, 210); // Professional Blue
        doc.setFont("helvetica", "bold");
        doc.text(companyName || 'COMPANY NAME', 35, 20);
        
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.setFont("helvetica", "normal");
        doc.text('ATTENDANCE REPORT', 155, 20);

        // Decorative Line
        doc.setDrawColor(200);
        doc.line(14, 28, 196, 28);

        // --- 2. Table Configuration ---
        const tableHeaders = [[
            'S.No', 
            'Date', 
            'Employee Name', 
            'In Time', 
            'Last Out Time', 
            'Work Hrs', 
            'Last Site'
        ]];

        const tableData = dataList.map((item, idx) => [
            idx + 1,
            item.punch_date || '-',
            item.employee_name || 'N/A',
            // Extracting just the Time portion from the full timestamp
            item.in_time ? item.in_time.split(' ')[1] : '-',
            item.out_time ? item.out_time.split(' ')[1] : '-',
            item.working_hours || '00:00:00',
            item.site_name || '-'
        ]);

        // --- 3. Generate Table ---
        doc.autoTable({
            startY: 35,
            head: tableHeaders,
            body: tableData,
            theme: 'striped',
            headStyles: { 
                fillColor: [25, 118, 210], 
                textColor: [255, 255, 255],
                fontSize: 10,
                fontStyle: 'bold'
            },
            styles: { 
                fontSize: 9, 
                cellPadding: 3 
            },
            columnStyles: {
                0: { cellWidth: 12 }, // S.No
                1: { cellWidth: 25 }, // Date
                5: { halign: 'center' }, // Work Hrs
            },
            didDrawPage: (data) => {
                // Footer logic (Page numbers)
                const str = "Page " + doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                doc.setTextColor(150);
                doc.text(str, 196, 285, { align: 'right' });
                doc.text("Generated on: " + new Date().toLocaleString(), 14, 285);
            }
        });

        // --- 4. Finalize and Save ---
        const timestamp = new Date().getTime();
        doc.save(`${companyName.replace(/\s+/g, '_')}_Attendance_${timestamp}.pdf`);

    } catch (error) {
        console.error("PDF Generation Error:", error);
        alert("Something went wrong while generating the PDF");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadAttendancePdf;